'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_CLDRMetadata(isoCountries, iso3Countries, isoLanguages, iso3Languages, scripts) {
  this.vE = null;
  this.vC = null;
  this.vF = null;
  this.vD = null;
  this.vG = null;
  this.vE = isoCountries;
  this.vC = iso3Countries;
  this.vF = isoLanguages;
  this.vD = iso3Languages;
  this.vG = scripts;
}
export { $c_Llocales_cldr_CLDRMetadata as $c_Llocales_cldr_CLDRMetadata };
$p = $c_Llocales_cldr_CLDRMetadata.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $h_Llocales_cldr_CLDRMetadata() {
}
export { $h_Llocales_cldr_CLDRMetadata as $h_Llocales_cldr_CLDRMetadata };
$h_Llocales_cldr_CLDRMetadata.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CLDRMetadata)) {
    var x = this.vE;
    var x$2 = x$0.vE;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.vC;
      var x$4 = x$0.vC;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.vF;
      var x$6 = x$0.vF;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.vD;
      var x$8 = x$0.vD;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.vG;
      var x$10 = x$0.vG;
      return ((x$9 === null) ? (x$10 === null) : (x$9 === x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 5;
});
$p.o = (function() {
  return "CLDRMetadata";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.vE;
      break;
    }
    case 1: {
      return this.vC;
      break;
    }
    case 2: {
      return this.vF;
      break;
    }
    case 3: {
      return this.vD;
      break;
    }
    case 4: {
      return this.vG;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dW)));
}
export { $isArrayOf_Llocales_cldr_CLDRMetadata as $isArrayOf_Llocales_cldr_CLDRMetadata };
var $d_Llocales_cldr_CLDRMetadata = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_CLDRMetadata, "locales.cldr.CLDRMetadata", ({
  dW: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_CLDRMetadata as $d_Llocales_cldr_CLDRMetadata };
